import React from 'react';
import PropTypes from 'prop-types';

import { Link as RouterLink, useLocation } from 'react-router-dom';

function Link({ to, children }) {
  const location = useLocation();

  return <RouterLink to={`${to}${location.search}`}>{children}</RouterLink>;
}

Link.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Link;
